import { RequestOptions } from "@cinnamon/design-system";
import apiService from "./apiService";

export async function request(configs: RequestOptions = {}) {
  const axiosConfigs: RequestOptions = { ...configs, headers: { "x-api-schema": "internal" } };

  return apiService.request(axiosConfigs);
}
